import styled from "styled-components";

export const Splitter = styled.hr`
  border: 0;
  margin: ${(p) => p.theme.sizes.x5} auto;
  width: 95%;
  border-top: 1px solid ${(p) => p.theme.colors.primary};
`;
